var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgInfoPurple = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5C3.58214 0.5 0 4.08214 0 8.5C0 12.9179 3.58214 16.5 8 16.5C12.4179 16.5 16 12.9179 16 8.5C16 4.08214 12.4179 0.5 8 0.5Z",
    fill: "#7F7EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14453 5.35714C7.14453 5.58447 7.23485 5.80249 7.39562 5.96323C7.55638 6.12398 7.77443 6.21429 8.00179 6.21429C8.22915 6.21429 8.44719 6.12398 8.60796 5.96323C8.76872 5.80249 8.85904 5.58447 8.85904 5.35714C8.85904 5.12981 8.76872 4.9118 8.60796 4.75105C8.44719 4.59031 8.22915 4.5 8.00179 4.5C7.77443 4.5 7.55638 4.59031 7.39562 4.75105C7.23485 4.9118 7.14453 5.12981 7.14453 5.35714ZM8.43041 7.35714H7.57316C7.49458 7.35714 7.43028 7.42143 7.43028 7.5V12.3571C7.43028 12.4357 7.49458 12.5 7.57316 12.5H8.43041C8.509 12.5 8.57329 12.4357 8.57329 12.3571V7.5C8.57329 7.42143 8.509 7.35714 8.43041 7.35714Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfoPurple, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/info-purple.af64e7f6.svg";
export { ForwardRef as ReactComponent };